import { render, staticRenderFns } from "./TokuteiDisease.vue?vue&type=template&id=aed872f4&"
import script from "./TokuteiDisease.vue?vue&type=script&lang=ts&"
export * from "./TokuteiDisease.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports